import { Button } from "antd";
import {useNavigate, useLocation } from "react-router-dom";
import userInfo from "@/Components/user";

const Navbar = () => {
    const navigate = useNavigate();
      const location = useLocation();
  //普通用户没有项目管理列表，这里改为流程管理（流程列表页）
  const isNormalUser = userInfo?.role === "user";
  const homePath = isNormalUser ? "/project/home/userView" : "/project/home/list";
  return (
    <div className="settingSelectorArea" style={{justifyContent:"start",gap:"20px"}}>
                {/* <Button
                  type={location.pathname.includes(`/project/${138}/flow/${532}/fixedData`) ? "primary" : "default"}
                  onClick={() => navigate(`/project/${138}/flow/${532}/fixedData`)}
                >
                  运行模型
                </Button> */}
                <Button
                  type={location.pathname.includes(homePath) ? "primary" : "default"}
                  onClick={() => navigate(homePath)}
                >
                  {isNormalUser ? "流程管理" : "项目管理"}
                </Button>
                <Button
                  type={location.pathname.includes("/project/home/data") ? "primary" : "default"}
                  onClick={() => navigate("/project/home/data")}
                >
                  数据接入
                </Button>
                {!isNormalUser && (
                  <Button
                    type={location.pathname.includes("/project/home/observation") ? "primary" : "default"}
                    onClick={() => navigate("/project/home/observation")}
                  >
                    实时监控
                  </Button>
                )}
                
              </div>
  );
};
export default Navbar;
